import { styled } from "@mui/material";

import { KeyValuePair } from "./key-value-pair";

export const Grid = styled("div")(({ theme }) => ({
  display: "grid",
  fontWeight: theme.typography.fontWeightLight,
  gap: theme.spacing(4, 1.5),
  gridTemplateColumns: "2fr 3fr",
  width: "fit-content",

  [`& > ${KeyValuePair.slots.Label}`]: {
    margin: 0,
  },
}));
